import styled from "styled-components";
import colors from "@/theme/colors";
import { ReactComponent as OffSiteProductIcon } from "../../../assets/off-site-product-icon.svg";

export const HomePageHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.5fr 1fr;
  align-items: center;
  background: ${colors.primaryOzone500};
  padding: 16px 24px;
`;

export const HomePageHeaderLeftContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 20px;
  justify-content: flex-start;
`;

export const HomePageHeaderCenterContainer = styled.div`
  display: grid;
  align-items: center;
  row-gap: 10px;
  padding: 0 16px;
`;

export const LogoImageContainer = styled.div`
  justify-self: flex-start;
`;

export const SearchContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  column-gap: 10px;
  place-items: center center;
`;

export const HomePageHeaderRightContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 20px;
  justify-content: flex-end;
  flex-wrap: nowrap;
  min-width: 340px;
  white-space: nowrap;
`;

export const ToggleSwitchRoot = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 24px;
  padding: 2px 4px;
  position: relative;
  min-width: 220px;
  height: 44px;
  box-sizing: border-box;
  border: 2px solid #fff;
`;

export const ToggleLabel = styled.div<{ active?: boolean }>`
  display: flex;
  align-items: center;
  font-family: 'PF DIN Text Pro', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: ${({ active }) => (active ? '#fff' : 'rgba(255,255,255,0.5)')};
  transition: color 0.2s;
  padding: 0 12px;
  cursor: pointer;
  z-index: 2;
`;

export const ToggleLabelOutside = styled.div<{ active?: boolean }>`
  font-family: 'PF DIN Text Pro', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: ${({ active }) => (active ? '#fff' : colors.neutralGrey600)};
  cursor: pointer;
  user-select: none;
  transition: color 0.2s, font-weight 0.2s;
`;

export const TogglePill = styled.div`
  display: flex;
  align-items: center;
  background: #0076ff;
  border-radius: 24px;
  border: 2px solid #fff;
  height: 35px;
  min-width: 70px;
  padding: 0;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
`;

export const ToggleIconWrapper = styled.div<{ active?: boolean; clickable?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32.5px;
  height: 29px;
  border-radius: 50%;
  background: ${({ active }) => (active ? '#fff' : 'transparent')};
  color: ${({ active }) => (active ? '#0076ff' : colors.neutralGrey600)};
  box-shadow: ${({ active }) => (active ? '0 2px 8px rgba(0,0,0,0.10)' : 'none')};
  transition: background 0.2s, color 0.2s;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  &:hover {
    background: ${({ active }) => (active ? '#fff' : 'rgba(255,255,255,0.08)')};
  }
`;

export const StyledOffSiteProductIcon = styled(OffSiteProductIcon)<{active?: boolean}>`
  height: 22px;
  width: 22px;
  margin: 0;
  color: ${({ active }) => (active ? '#0076ff' : colors?.neutralGrey600 || '#7A7A7A')};
  path {
    fill: currentColor;
  }
`;